import {
  SUCCESS_BANNER_OPT_IN_ALERT,
  SUCCESS_BANNER_PRIORITY_OPT_IN_ALERT,
  SUCCESS_BANNER_OPT_OUT_ALERT
} from "../../../../../state/modules/savedItems/constants";
import {
  getIsSuccessBannerShowing,
  getSuccessBannerType
} from "../../../../../state/modules/savedItems/selectors";
import content from "app-content";

export default state => {
  if (getIsSuccessBannerShowing(state)) {
    switch (getSuccessBannerType(state)) {
      case SUCCESS_BANNER_OPT_IN_ALERT:
        return content.back_in_stock_confirmation;
      case SUCCESS_BANNER_PRIORITY_OPT_IN_ALERT:
        return content.pdp_early_back_in_stock_toast_message;
      case SUCCESS_BANNER_OPT_OUT_ALERT:
        return content.back_in_stock_disable_confirmation;
    }
  }
};
